// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"904abd68","494":"904abd68","1395":"904abd68","5309":"904abd68","6761":"904abd68","8190":"904abd68","8925":"904abd68"}[chunkId] + ".chunk.css";
};